type TextAlign = 'left' | 'center' | 'right';
type Tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div';

interface Text {
  text: string;
  margin?: number[];
  color: string;
  tag: Tag;
  fontStyle: string[];
  textAlign: TextAlign;
}

function TextComponent({ props }: { props: Text }) {
  const Tag: keyof JSX.IntrinsicElements = props.tag || 'div';
  return (
    <Tag
      style={{
        color: props.color,
        textAlign: props.textAlign,
        fontWeight: props.fontStyle.includes('bold') ? 'bold' : 'normal',
        fontStyle: props.fontStyle.includes('italic') ? 'italic' : 'normal',
        textDecoration: props.fontStyle.includes('underline')
          ? 'underline'
          : 'none',
      }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: props.text }}
    ></Tag>
  );
}

export default TextComponent;
